import React from 'react';

interface ProgressBarProps {
  percentage: number;
  showLabel?: boolean;
}

export const ProgressBar: React.FC<ProgressBarProps> = ({ percentage, showLabel = true }) => {
  const clampedPercentage = Math.min(Math.max(percentage, 0), 100);

  return (
    <div className="w-full">
      <div className="flex items-center justify-between mb-1">
        {showLabel && (
          <span className="text-xs text-gray-600">{clampedPercentage.toFixed(1)}%</span>
        )}
      </div>
      <div className="w-full bg-cream-300 dark:bg-dark-400 rounded-full h-2.5 overflow-hidden shadow-inner-soft">
        <div
          className="bg-gradient-to-r from-warm-500 to-warm-400 dark:from-dark-purple-200 dark:to-dark-purple-300 h-2.5 rounded-full transition-all duration-300"
          style={{ width: `${clampedPercentage}%` }}
        />
      </div>
    </div>
  );
};
